import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { AppContext } from "../../../providers/AppContextProvider";
import { CustomFieldsContextProvider } from "../../../providers/CustomFieldsContextProvider";
import { CustomFieldEntityType } from "../../../types/custom-field";
import { CustomFieldCreation } from "../CustomFieldCreation/CustomFieldCreation";
import { CustomFields } from "../CustomFields/CustomFields";
import { CustomFieldsAd } from "../CustomFieldsAd/CustomFieldsAd";
const descriptions = {
    [CustomFieldEntityType.User]: __("Add custom fields to this user only.", "quicktasker"),
    [CustomFieldEntityType.Users]: __("Add custom fields to all users. If you want to add custom fields to a specific user, please go to that user settings.", "quicktasker"),
    [CustomFieldEntityType.Pipeline]: __("Add custom fields to all tasks in this board.", "quicktasker"),
    [CustomFieldEntityType.Task]: __("Add custom fields to this task only. If you want to add custom fields to all tasks in this board, please go to board settings.", "quicktasker"),
};
const existingFieldsDescriptions = {
    [CustomFieldEntityType.User]: __("Add custom fields to this user only.", "quicktasker"),
    [CustomFieldEntityType.Users]: __("Add custom fields to all users. If you want to add custom fields to a specific user, please go to that user settings.", "quicktasker"),
    [CustomFieldEntityType.Pipeline]: __("Add custom fields to all tasks in this board.", "quicktasker"),
    [CustomFieldEntityType.Task]: __("Custom fields applied to this task, including both task-specific and board-level fields.", "quicktasker"),
};
const titles = {
    [CustomFieldEntityType.User]: __("User custom fields", "quicktasker"),
    [CustomFieldEntityType.Users]: __("Users custom fields", "quicktasker"),
    [CustomFieldEntityType.Pipeline]: __("Board custom fields", "quicktasker"),
    [CustomFieldEntityType.Task]: __("Task custom fields", "quicktasker"),
};
function CustomFieldsInModalWrap({ entityId, entityType }) {
    const { state: { is_customFields }, } = useContext(AppContext);
    const creationDescription = descriptions[entityType];
    const customFieldsTitle = titles[entityType];
    const customFieldsDescription = existingFieldsDescriptions[entityType];
    return (_jsx(_Fragment, { children: is_customFields ? (_jsx("div", { children: _jsxs(CustomFieldsContextProvider, { entityId: entityId, entityType: entityType, children: [_jsx(CustomFieldCreation, { description: creationDescription }), _jsx("h2", { className: "wpqt-text-center", children: customFieldsTitle }), _jsx("div", { className: "wpqt-mb-4 wpqt-text-center", children: customFieldsDescription }), _jsx(CustomFields, {})] }) })) : (_jsx(CustomFieldsAd, {})) }));
}
export { CustomFieldsInModalWrap };
